import { ModelFilterOption } from '../types/globalapi/filters';

export const isDisabled = ({ new: newCount, used, certified, demo }: ModelFilterOption, categories: string[]) => {
  if (categories.length === 0) {
    return false;
  }
  let total = 0;
  if (categories?.includes("new")) {
    total += newCount;
  }
  if (categories?.includes("used")) {
    total += used;
  }
  if (categories?.includes("certified")) {
    total += certified;
  }
  if (categories?.includes("demo") && demo) {
    total += demo;
  }
  return !Boolean(total);
};
